<template>
    <div>
        <div v-if="authInformation" class="mt-4">
            <ConnectAuthenticationMethodLine class="mb-2" 
                v-for="lm in authInformation.login_methods"
                :key="lm.login_method_title"
                :title="lm.login_method_title"
                :logo="lm.login_method_logo"
                :connectUrl="lm.connect_url"
                :verified="true"
                :connected="isLoginMethodConnected(lm.provider_id)"
                :verificationUrl="'asdf'"
                :hasUsablePassword="authInformation.has_usable_password"
                :lmType="lm.login_method_type"
                :tuId="authInformation.tenant_user_id"
                :lmId="lm.login_method_id"
                :currentLoginMethod="getCurrentLoginMethod"
                @disconnect-login-method="disconnectLoginMethod"
            ></ConnectAuthenticationMethodLine>
        </div>
    </div>
</template>

<script>

import ConnectAuthenticationMethodLine from "@/components/auth/authentication-method/ConnectAuthenticationMethodLine.vue";
import {suppliosApi} from '@/js/api-service'

export default {
    name: 'ConnectSocialAccounts',
    components: { ConnectAuthenticationMethodLine },
    props: {
        tenant: {
            type: String,
            required: true
        },
        tuid: {
            type: String,
            required: true
        },
        lmid: {
            type: String,
            required: true 
        }
    },
    data: function() {
        return {
            searchParams: location.href.split('?')[1] || '',
            authInformation: null,
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {
        // TODO - stop using sa.uid to match email address -- not always correct!
        getCurrentLoginMethod() {
            const lm = this.authInformation.login_methods.find(lm => 
                lm.login_method_id === this.lmid && 
                this.authInformation.user_socialaccounts.find(
                    sa => 
                        sa.provider_id === lm.provider_id &&
                        sa.uid == this.authInformation.email
                )
            );
            if (lm) {
                return lm.login_method_id;
            }
            return '';

        },
    },
    mounted: function() {
        this.getTenantUserAuthenticationInformation()
    },
    methods: {
        async disconnectLoginMethod(tuId, lmId) {
            try {
                await suppliosApi.auth.disconnectLoginMethod(tuId, lmId)
                await this.getTenantUserAuthenticationInformation();
            }
            catch(error) {
                this.apiErrorHandler(error, "Error while getting user's permissions");
            }
        },
        isLoginMethodConnected(provider_id) {
            if (provider_id == 'password') {
                return this.authInformation.has_usable_password;
            }
            if (this.authInformation) {
                if (this.authInformation.user_socialaccounts.find(sa => sa.uid ===this.authInformation.email && sa.provider_id === provider_id)) {
                    return true;
                }
            }
            return false;
        },
        async getTenantUserAuthenticationInformation() {
            const authInformation = await suppliosApi.auth.getTenantUserAuthenticationInformation(this.tuid);
            this.authInformation = authInformation;
        }
    }
}
</script>

<style scoped lang="scss">
.login_input {
    font-size: 12pt;
    padding: 1.15rem;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.authentication-method-card {
    margin-top: 1rem;
}
.authentication-method-card:hover {
    background-color: rgba(33, 33, 33, 0.1);
    /* cursor: context-menu; */
}

.login_button {
    padding: 0.7rem;
}

b-form-group .input-group-text {
  width: 48px;
  border-right: none;
  background-color: #ffffff;
}
b-form-group [class^="bicon"], [class*=" bicon"] {
  display: inline-block;
  width: 100%;
}
</style>
